import SettingsEllipsis from './SettingsEllipsis';

export default SettingsEllipsis;
